import type {
  CustomerZonePostcodeAddRequestType,
  CustomerZonePostcodeAddResponseType,
} from "@sellar-io/api-v2/types";
import { useMutation, useQueryClient } from "@tanstack/react-query";
import { useFirebaseUser } from "../../../useFirebaseUser.shared";
import { useSellarCurrentBusiness } from "../../../useSellarCurrentBusiness.shared";
import { apiV2AssertResponse, apiV2Request } from "../apiV2Request";
import { ServerStateKeys } from "../ServerStateKeys";

export const useCustomerZonePostcodesAdd = (customerZoneId: number) => {
  const queryClient = useQueryClient();
  const { business } = useSellarCurrentBusiness();
  const { user } = useFirebaseUser();

  return useMutation({
    mutationFn: (
      data: CustomerZonePostcodeAddRequestType & { customerZoneId?: number },
    ) =>
      apiV2Request({
        user,
        business,
        method: "post",
        path: `customer-zones/${customerZoneId !== 0 ? customerZoneId : data.customerZoneId}/postcodes`,
        data: {
          postcodeComponents: data.postcodeComponents,
        },
      }).then(
        (data) =>
          apiV2AssertResponse(data).data as CustomerZonePostcodeAddResponseType,
      ),
    onSuccess: () => {
      queryClient.invalidateQueries({
        queryKey: [
          user?.uid,
          business?.id,
          ServerStateKeys.CustomerZonePostcodes,
          customerZoneId,
        ],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.DeliveryArea],
      });
      queryClient.invalidateQueries({
        queryKey: [user?.uid, business?.id, ServerStateKeys.Suppliers],
      });
    },
  });
};
